import { authHeaders, Axios } from "@/utils/axios";
import { Role } from "@/utils/constant";
import { API_END_POINTS } from "@/utils/routes";
import { create } from "zustand";
import { persist } from "zustand/middleware";


export interface contractsData {
    data: dataValue[],
    globalSummary: {
        activeContracts: number,
        activeValue: number,
        totalContracts: number,
        totalValue: number
    },
    limit: number,
    page: number,
    total: number,
    totalPages: number
}

export interface dataValue {
    contract: contractDetails,
    enterprise?: enterpriseDetails,
    freelancer?: freelancerDetails,
    job: jobDetails,
    milestones: milestone[] | null
    reviews: null | reviewRating;
}

interface reviewRating {
    enterpriseReview: null | freelancerAndEnterpriseReview,
    freelancerReview: null | freelancerAndEnterpriseReview,
}

interface freelancerAndEnterpriseReview {
    contractId: string,
    createdAt: string,
    enterpriseId: string,
    rating: number,
    review: string,
    updatedAt: string,
    _id: string,
}

export interface contractDetails {
    _id: string,
    budget: number,
    jobId?: string | number,
    freelancerId?: string,
    paymentTerm: number | string,
    durationValue: number | string,
    durationUnit: number | string,
    status?: number,
    startDate: string | null,
    endDate: string | null,
    terms: string | null,
    notes: string | null,
    paymentMethod: number | null,
    currency: number | null,
    cryptoToken: number | null,
    attachment?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    file?: File,
    milestones?: null | milestone[] | any,
}

export interface milestone {
    paymentReleased: boolean;
    _id?: string,
    contractId: string,
    title: string,
    description: string | null,
    index?: number,
    amount: string,
    status: string,
    startDate: string,
    dueDate: string,
    isPaid?: boolean,
    createdAt?: string,
    updatedAt?: string,
    reviews: review[] | null,
    __v?: 0,
}

interface review {
    createdAt: string,
    message: string,
    requireRework: boolean
    reviewedBy: string,
    _id: string
}

interface jobDetails {
    _id: string;
    title: string;
    description: string;
    category: string;
}

interface freelancerDetails {
  binanceId: string;
  profilePicture: any;
    _id: string;
  fullName: string;
  name: string;
  userId: string;
  experience: number;
  phone: string;
  designation: string;
  rating: number;
  skills: string[];
  category: string;
  projectsCompleted: number;
  resume_url: string | null;
  certifications: string[];
  achievements: string[];
  dailyRate: number;
  totalEarnings: number;
  bio: string;
  availability: boolean;
  socialMediaLinks: {
    _id: string;
  }[];
  education: Education[];
  project: any;
  location: string;
  createdAt: string;
  updatedAt: string;
  avatarUrl?: string;
}

interface Education {
  degree: string;
  institution: string;
  year: string;
}

interface enterpriseDetails {
    contactPerson: {
        name: string,
        email: string | null,
        phone: string | null
    },
    location: {
        address: string | null,
        city: string | null,
        country:string | null
    },
    _id: string,
    companyName: string | null
}

export interface acceptContract {
    termsAccepted: boolean,
    acceptedByFreelancer: boolean,
    ndaDocument: File | null
}

export interface TermAndCondition {
  heading: string;
  type: "checkbox" | "file";
  isAccepted?: boolean;
  file?: File | null;
}

interface ContractState {
    allContractsBasedOnFreelancerID: contractsData,
    isLoading: boolean;
    error: string | null;
    fetchAllContractsBasedOnFreelancerID:(freelancerOREnterPriseId: string, token: string, role: string, contractFilter: number | string | null, submittedSearchTerm: string | null, pageNumber: number) => Promise<void>;
}

export const useContractStore = create<ContractState>()(
    persist(
        (set) => ({
            allContractsBasedOnFreelancerID: null,
            isLoading: false,
            error: null,

            fetchAllContractsBasedOnFreelancerID: async (freelancerOREnterPriseId, token, role, contractFilter, submittedSearchTerm, pageNumber) => {
                set({ isLoading: true, error: null });
                try {
                    const baseUrl =
                        role !== Role.ENTERPRISE
                            ? API_END_POINTS.GET_CONTRACT_BASED_ON_FREELANCER
                            : API_END_POINTS.GET_CONTRACT_BASED_ON_ENTERPRISE;
                    const url = `${baseUrl}${freelancerOREnterPriseId}?search=${submittedSearchTerm}&status=${contractFilter}&page=${pageNumber}&limit=5`;
                    const res = await Axios.get(url, authHeaders(token));
                    set({ allContractsBasedOnFreelancerID: res.data, isLoading: false });
                } catch (err: any) {
                    set({ error: err.message, isLoading: false });
                }
            },
        }),
        {
            name: "contract-storage",
        }
    )
)